export default function DockerHeader() {
  return (
    <>
      <h2 className="mb-3 text-xs font-black uppercase tracking-[0.18em] text-slate-400">Live logs</h2>
      <p className="text-sm leading-relaxed text-slate-400">
        <span className="font-semibold text-slate-200">backend … frontend</span> — SSE from{' '}
        <code className="rounded border border-white/10 bg-slate-950/70 px-1.5 py-0.5 text-xs text-cyan-200">
          docker compose logs -f --no-color
        </code>
        . <span className="font-semibold text-slate-200">traffic</span> — aggregated events +{' '}
        <code className="rounded border border-white/10 bg-slate-950/70 px-1.5 py-0.5 text-xs text-cyan-200">
          /dashboard/stream-gate
        </code>
        , polled every 5s. Colors: info / warning / error (heuristic). Use{' '}
        <span className="font-semibold text-fuchsia-300">[SCAN START/END]</span> +{' '}
        <span className="font-semibold text-cyan-300">Filter by scan</span> to isolate one investigation.
      </p>
    </>
  );
}
